/** Takvim form varsayılanları ve yardımcılar */

export function toDatetimeLocal(val) {
    if (!val) return "";
    const d = val instanceof Date ? val : new Date(val);
    if (Number.isNaN(d.getTime())) return "";
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const h = String(d.getHours()).padStart(2, "0");
    const min = String(d.getMinutes()).padStart(2, "0");
    return `${y}-${m}-${day}T${h}:${min}`;
}

export function defaultRandevuForm(dayKey, hour = 10) {
    const base = dayKey || new Date().toISOString().slice(0, 10);
    const h = String(hour).padStart(2, "0");
    const h2 = String(Math.min(hour + 1, 23)).padStart(2, "0");
    return {
        tip: "randevu",
        baslik: "",
        baslangic: `${base}T${h}:00`,
        bitis: `${base}T${h2}:00`,
        gorusme_tipi: "gorusme",
        onem: "orta",
        durum: "planlandi",
        konum: "",
        aciklama: "",
        tum_gun: false,
    };
}

export function defaultHatirlatmaForm(dayKey, hour = 9) {
    const base = dayKey || new Date().toISOString().slice(0, 10);
    const h = String(hour).padStart(2, "0");
    return {
        tip: "hatirlatma",
        baslik: "",
        hatirlatma_zamani: `${base}T${h}:00`,
        yontem: "sistem",
        aciklama: "",
        ofset_dk: 0,
        gonderildi_mi: false,
    };
}

export function defaultEtkinlikForm(dayKey, hour = 10) {
    const base = dayKey || new Date().toISOString().slice(0, 10);
    const h = String(hour).padStart(2, "0");
    return {
        tip: "takvim",
        baslik: "",
        baslangic: `${base}T${h}:00`,
        bitis: `${base}T${String(Math.min(hour + 1, 23)).padStart(2, "0")}:00`,
        etkinlik_turu: "DIGER",
        tur: "TEK_GUN",
        aciklama: "",
        hatirlatma_var_mi: true,
        hatirlatma_suresi: 1,
    };
}

export const CRUD_RESOURCE = {
    randevu: "randevular",
    hatirlatma: "hatirlatmalar",
    takvim: "takvim-etkinlikleri",
};

export async function loadFormFromEvent(crud, event) {
    if (!event?.source || !event?.recordId) return null;
    const resource = CRUD_RESOURCE[event.source];
    if (!resource) return null;
    try {
        const row = await crud.retrieve(resource, event.recordId);
        if (event.source === "randevu") {
            return {
                tip: "randevu",
                id: row.id,
                baslik: row.baslik || "",
                baslangic: toDatetimeLocal(row.baslangic),
                bitis: toDatetimeLocal(row.bitis),
                gorusme_tipi: row.tip || "gorusme",
                onem: row.onem || "orta",
                durum: row.durum || "planlandi",
                konum: row.konum || "",
                aciklama: row.aciklama || "",
                tum_gun: !!row.tum_gun,
            };
        }
        if (event.source === "hatirlatma") {
            return {
                tip: "hatirlatma",
                id: row.id,
                baslik: row.baslik || "",
                hatirlatma_zamani: toDatetimeLocal(row.hatirlatma_zamani),
                yontem: row.yontem || "sistem",
                aciklama: row.aciklama || "",
                ofset_dk: row.ofset_dk || 0,
                gonderildi_mi: !!row.gonderildi_mi,
            };
        }
        if (event.source === "takvim") {
            return {
                tip: "takvim",
                id: row.id,
                baslik: row.baslik || "",
                baslangic: toDatetimeLocal(row.baslangic),
                bitis: toDatetimeLocal(row.bitis),
                etkinlik_turu: row.etkinlik_turu || "DIGER",
                tur: row.tur || "TEK_GUN",
                aciklama: row.aciklama || "",
                hatirlatma_var_mi: row.hatirlatma_var_mi !== false,
                hatirlatma_suresi: row.hatirlatma_suresi ?? 1,
            };
        }
    } catch {
        return null;
    }
    return null;
}

export function payloadFromForm(form) {
    if (form.tip === "randevu") {
        return {
            tip: "randevu",
            baslik: form.baslik,
            baslangic: form.baslangic,
            bitis: form.bitis,
            tip_randevu: form.gorusme_tipi,
            onem: form.onem,
            durum: form.durum,
            konum: form.konum,
            aciklama: form.aciklama,
            tum_gun: form.tum_gun,
        };
    }
    if (form.tip === "hatirlatma") {
        return {
            tip: "hatirlatma",
            baslik: form.baslik,
            hatirlatma_zamani: form.hatirlatma_zamani,
            yontem: form.yontem,
            aciklama: form.aciklama,
            ofset_dk: form.ofset_dk,
            gonderildi_mi: form.gonderildi_mi,
        };
    }
    return {
        tip: "takvim",
        baslik: form.baslik,
        baslangic: form.baslangic,
        bitis: form.bitis,
        etkinlik_turu: form.etkinlik_turu,
        tur: form.tur,
        aciklama: form.aciklama,
        hatirlatma_var_mi: form.hatirlatma_var_mi,
        hatirlatma_suresi: form.hatirlatma_suresi,
    };
}
